import FieldText from '../../../components/general/fields/fieldText';

type Props = {
    value?: string;
    showError?: boolean;
    errorMessage?: string;
};

export const OrbitFullAddressField = ({
    value,
    showError,
    errorMessage,
}: Props) => (
    <FieldText
        label="Dirección completa"
        name="address"
        size="small"
        disabled
        placeholder="Se genera automáticamente"
        value={value}
        touched={showError}
        errors={showError ? errorMessage : undefined}
    />
);
